import Vue from 'vue'
import urls from '../services.url.js'
import store from '../../store/index.js'

export default {
  getRanking () {
    if (store.getters.activatedLeague !== null) {
      let league = store.getters.activatedLeague
      return Vue.http.get(urls.RANKING_URL + '?league=' + league)
    } else {
      return Vue.http.get(urls.RANKING_URL)
    }
  },
  getRankingForWeek (weekId) {
    return Vue.http.get(urls.RANKING_URL + '?week=' + weekId)
  }
}



// WEBPACK FOOTER //
// ./src/api/real-api/ranking.api.js